import { api } from '../utils/data-utils';
import { mapWithConcurrency } from '../utils/map-with-concurrency';
import type { FetchFormResponse } from './types';
import type { ModerationReportMetadata } from '../screens/ScsModeration/service';

export type ScsPanelReportRecord = FetchFormResponse & {
  reportMetadata: ModerationReportMetadata;
};

export const fetchScsPanelReportRecords = async (
  token: string,
  formIds: string[],
  year: string,
): Promise<ScsPanelReportRecord[]> => {
  const ids = [...new Set(formIds)];
  const batches: string[][] = [];
  for (let index = 0; index < ids.length; index += 50) {
    batches.push(ids.slice(index, index + 50));
  }
  const records = await mapWithConcurrency(batches, 2, async (batch) => {
    const response = await api(token, '/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ report_type: 'scs_panel_report', form_ids: batch, year }),
    });
    const result = await response.json();
    const rows: ScsPanelReportRecord[] = result?.records;
    const excluded: string[] = result?.excludedFormIds ?? [];
    const returnedIds = Array.isArray(rows) ? rows.map((row) => row?.formId) : [];
    if (
      !Array.isArray(rows) ||
      !Array.isArray(excluded) ||
      rows.length + excluded.length !== batch.length ||
      new Set([...returnedIds, ...excluded]).size !== batch.length ||
      excluded.some((id) => !batch.includes(id)) ||
      rows.some((row) => !batch.includes(row?.formId || '') || !row?.answers)
    ) {
      throw new Error('Report responses are missing or have changed. Refresh and try again.');
    }
    return rows;
  });
  return records.flat();
};
